import * as goldenrush from './IncreaseAmountButton.styles.goldenrush';
import * as juicybet from './IncreaseAmountButton.styles.juicybet';
import * as vikingbet from './IncreaseAmountButton.styles.vikingbet';
import * as fiestabet from './IncreaseAmountButton.styles.fiestabet';
import * as oldgill from './IncreaseAmountButton.styles.oldgill';
import * as sugarcastle from './IncreaseAmountButton.styles.sugarcastle';
import * as buffalobet from './IncreaseAmountButton.styles.buffalobet';
import * as titanbet from './IncreaseAmountButton.styles.titanbet';
import * as slambet from './IncreaseAmountButton.styles.slambet';
import * as gigabet from './IncreaseAmountButton.styles.gigabet';
import * as betstride from './IncreaseAmountButton.styles.betstride';
import * as chromabet from './IncreaseAmountButton.styles.chromabet';
import * as templebet from './IncreaseAmountButton.styles.templebet';
import * as hyperbet from './IncreaseAmountButton.styles.hyperbet';
import * as bet777 from './IncreaseAmountButton.styles.bet777';
import * as bet575 from './IncreaseAmountButton.styles.bet575';
import * as epicodds from './IncreaseAmountButton.styles.epicodds';
import * as magnumbet from './IncreaseAmountButton.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  vikingbet,
  fiestabet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  chromabet,
  templebet,
  hyperbet,
  bet777,
  bet575,
  epicodds,
  magnumbet,
};
